'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = createStrategy;
var CONFIGURATION_DOM_SELECTOR = '.js-diffusionTopicSettings';
var CONFIGURATION_HOST_PROPERTY = 'data-diffusion-host';
var CONFIGURATION_PORT_PROPERTY = 'data-diffusion-port';
var CONFIGURATION_API_URL_PROPERTY = 'data-diffusion-stub-url';

function createStrategy() {
    return {
        getConfig: function getConfig() {
            var diffusionServerConfig = global.document.querySelector(CONFIGURATION_DOM_SELECTOR);
            if (!diffusionServerConfig) {
                throw new Error('Where is no diffusion configuration node');
            }
            var host = diffusionServerConfig.getAttribute(CONFIGURATION_HOST_PROPERTY);
            var port = diffusionServerConfig.getAttribute(CONFIGURATION_PORT_PROPERTY);
            return {
                host: host,
                port: port,
                secure: true
            };
        },
        getStubConfig: function getStubConfig() {
            var diffusionServerConfig = global.document.querySelector(CONFIGURATION_DOM_SELECTOR);
            var url = diffusionServerConfig ? diffusionServerConfig.getAttribute(CONFIGURATION_API_URL_PROPERTY) + 'api/' : null;
            return {
                url: url
            };
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/providers/domConfigurationStrategy.js
// module id = 593
// module chunks = 1